// Stop awaiting an uncancellable vendor operation when `signal` fires, and hand a late result to
// `discard` (e.g. delete() a runtime that finished starting after we gave up). This does not
// pretend to cancel CheerpX's workers or network I/O. Ported from EndisOS.
import { LinuxError } from "../engine.js";

export function awaitOperation(operation, signal, discard) {
	return new Promise((resolve, reject) => {
		let cancelled = false;
		const abort = () => {
			cancelled = true;
			signal.removeEventListener("abort", abort);
			reject(signal.reason instanceof LinuxError ? signal.reason : new LinuxError("ABORTED", "The Linux operation was cancelled."));
		};
		if (signal.aborted) abort(); else signal.addEventListener("abort", abort, { once: true });
		Promise.resolve(operation).then(
			(v) => { signal.removeEventListener("abort", abort); if (cancelled) { if (discard) { try { discard(v); } catch (e) {} } } else resolve(v); },
			(e) => { signal.removeEventListener("abort", abort); reject(e); }
		);
	});
}
